import { $api } from "services/AxiosInstance";

export class LanguageService {
    static getAll() {
        return $api.get("/api/admin/language/all");
    }
}
